struct Params_std140_0
{
    @align(16) worldSize_0 : vec2<f32>,
    @align(8) viewSize_0 : vec2<f32>,
    @align(16) gridSize_0 : vec2<f32>,
    @align(8) dotSize_0 : vec2<f32>,
    @align(16) fieldUvScale_0 : vec2<f32>,
    @align(8) pointer_0 : vec2<f32>,
    @align(16) pointerRadius_0 : f32,
    @align(4) pointerForce_0 : f32,
    @align(8) particleCount_0 : f32,
    @align(4) binCount_0 : f32,
    @align(16) binSize_0 : f32,
    @align(4) returnForce_0 : f32,
    @align(8) returnDamping_0 : f32,
    @align(4) dt_0 : f32,
    @align(16) mu_k_0 : f32,
    @align(4) sigma_k_0 : f32,
    @align(8) w_k_0 : f32,
    @align(4) mu_g_0 : f32,
    @align(16) sigma_g_0 : f32,
    @align(4) c_rep_0 : f32,
    @align(8) r_rep_0 : f32,
    @align(4) resetAttempts_0 : f32,
    @align(16) initialFieldScattering_0 : f32,
};

@binding(0) @group(0) var<uniform> data_params_0 : Params_std140_0;
struct Particle_std430_0
{
    @align(8) position_0 : vec2<f32>,
    @align(8) velocity_0 : vec2<f32>,
    @align(8) home_0 : vec2<f32>,
    @align(8) frame_0 : u32,
    @align(4) _pad_0 : u32,
};

@binding(1) @group(0) var<storage, read_write> data_particles_0 : array<Particle_std430_0>;

struct Frame_std430_0
{
    @align(8) origin_0 : vec2<f32>,
    @align(8) scale_0 : vec2<f32>,
};

@binding(2) @group(0) var<storage, read> data_frames_0 : array<Frame_std430_0>;

@binding(3) @group(0) var data_sampler_0 : sampler;

@binding(4) @group(0) var data_texture_0 : texture_2d<f32>;

fn hash3_0( ix_0 : vec3<i32>) -> vec3<f32>
{
    var x_0 : vec3<u32> = (bitcast<vec3<u32>>((ix_0)));
    const _S1 : vec3<u32> = vec3<u32>(u32(8), u32(8), u32(8));
    var _S2 : vec3<u32> = vec3<u32>(u32(1103515245));
    var x_1 : vec3<u32> = ((((x_0 >> (_S1))) ^ ((x_0.yzx)))) * _S2;
    var x_2 : vec3<u32> = ((((x_1 >> (_S1))) ^ ((x_1.yzx)))) * _S2;
    return vec3<f32>(((((x_2 >> (_S1))) ^ ((x_2.yzx)))) * _S2) * vec3<f32>(2.32830643653869629e-10f);
}

fn fieldWeight_0( uv_0 : vec2<f32>) -> f32
{
    var _S3 : vec2<f32> = vec2<f32>(0.5f);
    var imageUV_0 : vec2<f32> = (uv_0 - _S3) * data_params_0.fieldUvScale_0 + _S3;
    var _S4 : bool;
    if((any((imageUV_0 < vec2<f32>(0.0f)))))
    {
        _S4 = true;
    }
    else
    {
        _S4 = (any((imageUV_0 > vec2<f32>(1.0f))));
    }
    if(_S4)
    {
        return 0.0f;
    }
    return saturate(dot((textureSampleLevel((data_texture_0), (data_sampler_0), (imageUV_0), (0.0f))).xyz, vec3<f32>(0.2125999927520752f, 0.71520000696182251f, 0.07220000028610229f)));
}

fn sampleInitialUV_0( seed_0 : u32) -> vec2<f32>
{
    const _S5 : vec2<f32> = vec2<f32>(0.5f, 0.5f);
    var bestWeight_0 : f32 = -1.0f;
    var bestUV_0 : vec2<f32> = _S5;
    var attempt_0 : i32 = i32(0);
    for(;;)
    {
        if(f32(attempt_0) < (data_params_0.resetAttempts_0))
        {
        }
        else
        {
            break;
        }
        var r_0 : vec3<f32> = hash3_0(vec3<i32>(i32(seed_0), attempt_0, i32(0)));
        var uv_1 : vec2<f32> = r_0.xy;
        var weight_0 : f32 = fieldWeight_0(uv_1);
        if(weight_0 > bestWeight_0)
        {
            bestWeight_0 = weight_0;
            bestUV_0 = uv_1;
        }
        if((r_0.z) <= weight_0)
        {
            return uv_1;
        }
        attempt_0 = attempt_0 + i32(1);
    }
    return bestUV_0;
}

struct Particle_0
{
     position_0 : vec2<f32>,
     velocity_0 : vec2<f32>,
     home_0 : vec2<f32>,
     frame_0 : u32,
     _pad_0 : u32,
};

@compute
@workgroup_size(64, 1, 1)
fn resetField(@builtin(global_invocation_id) gid_0 : vec3<u32>)
{
    var _S6 : u32 = gid_0.x;
    if(f32(_S6) >= (data_params_0.particleCount_0))
    {
        return;
    }
    var _S7 : vec2<f32> = vec2<f32>(2.0f);
    var _S8 : vec2<f32> = vec2<f32>(1.0f);
    var _S9 : vec2<f32> = vec2<f32>(0.5f);
    var position_1 : vec2<f32> = (sampleInitialUV_0(_S6) * _S7 - _S8) * _S9 * data_params_0.worldSize_0;
    var particle_0 : Particle_0;
    particle_0.position_0 = position_1 + vec2<f32>(data_params_0.initialFieldScattering_0) * (hash3_0(vec3<i32>(i32(_S6), i32(0), i32(1))).xy * _S7 - _S8) * _S9 * data_params_0.worldSize_0;
    particle_0.velocity_0 = vec2<f32>(0.0f, 0.0f);
    particle_0.home_0 = position_1;
    particle_0.frame_0 = u32(0);
    particle_0._pad_0 = u32(0);
    data_particles_0[_S6].position_0 = particle_0.position_0;
    data_particles_0[_S6].velocity_0 = particle_0.velocity_0;
    data_particles_0[_S6].home_0 = particle_0.home_0;
    data_particles_0[_S6].frame_0 = particle_0.frame_0;
    data_particles_0[_S6]._pad_0 = particle_0._pad_0;
    return;
}

@compute
@workgroup_size(64, 1, 1)
fn resetFrames(@builtin(global_invocation_id) gid_1 : vec3<u32>)
{
    var _S10 : u32 = gid_1.x;
    if(f32(_S10) >= (data_params_0.particleCount_0))
    {
        return;
    }
    var particle_1 : Particle_0;
    particle_1.position_0 = data_particles_0[_S10].position_0;
    particle_1.velocity_0 = data_particles_0[_S10].velocity_0;
    particle_1.home_0 = data_particles_0[_S10].home_0;
    particle_1.frame_0 = data_particles_0[_S10].frame_0;
    particle_1._pad_0 = data_particles_0[_S10]._pad_0;
    var frame_1 : Frame_std430_0 = data_frames_0[particle_1.frame_0];
    particle_1.position_0 = frame_1.origin_0 + particle_1.home_0 * frame_1.scale_0;
    particle_1.velocity_0 = vec2<f32>(0.0f, 0.0f);
    particle_1._pad_0 = u32(0);
    data_particles_0[_S10].position_0 = particle_1.position_0;
    data_particles_0[_S10].velocity_0 = particle_1.velocity_0;
    data_particles_0[_S10].home_0 = particle_1.home_0;
    data_particles_0[_S10].frame_0 = particle_1.frame_0;
    data_particles_0[_S10]._pad_0 = particle_1._pad_0;
    return;
}

@compute
@workgroup_size(64, 1, 1)
fn resetRandom(@builtin(global_invocation_id) gid_2 : vec3<u32>)
{
    var _S11 : u32 = gid_2.x;
    if(f32(_S11) >= (data_params_0.particleCount_0))
    {
        return;
    }
    var position_2 : vec2<f32> = (hash3_0(vec3<i32>(i32(_S11), i32(0), i32(0))).xy * vec2<f32>(2.0f) - vec2<f32>(1.0f)) * vec2<f32>(0.5f) * data_params_0.worldSize_0;
    var particle_2 : Particle_0;
    particle_2.position_0 = position_2;
    particle_2.velocity_0 = vec2<f32>(0.0f, 0.0f);
    particle_2.home_0 = position_2;
    particle_2.frame_0 = u32(0);
    particle_2._pad_0 = u32(0);
    data_particles_0[_S11].position_0 = particle_2.position_0;
    data_particles_0[_S11].velocity_0 = particle_2.velocity_0;
    data_particles_0[_S11].home_0 = particle_2.home_0;
    data_particles_0[_S11].frame_0 = particle_2.frame_0;
    data_particles_0[_S11]._pad_0 = particle_2._pad_0;
    return;
}

